export default "__VITE_ASSET__2037c687__"